import { render, staticRenderFns } from "./presR.vue?vue&type=template&id=52dd55d2"
import script from "./presR.vue?vue&type=script&lang=js"
export * from "./presR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports